/**
 *Basic CRUD actions
 */
export default class CrudResetActions {
    resourceName;
    constructor(resourceName = "DATA") {
        this.resourceName = resourceName;
    }
    /**
     *
     * @param store
     * @param options
     */
    resetList(store, options) {
        store.commit("SET_DATA_LIST", []);
        store.commit("SET_TOTAL", 0);
        store.commit("SET_ERROR", null);
        store.commit("IS_LOADING", false);
    }
    /**
     *
     * @param store
     * @param options
     */
    resetSave(store, options) {
        store.commit("SET_SUCCESS", false);
        store.commit("SET_DATA_ITEM", null);
        store.commit("SET_DATA_ID", null);
        store.commit("SET_ERROR", null);
        store.commit("IS_LOADING", false);
    }
}
